module.exports = __webpack_public_path__ + "media/images/select_rectangle-78a9312339ae7e99bad2fb47f17209d3.svg";